import { NotFoundComponent } from './not-found.component';
import { AttachmentComponent } from './attachment/attachment.component';

export const COMMON_COMPONENTS: any[] = [
  NotFoundComponent,
  AttachmentComponent,
];

// services

export const COMMON_SERVICES: any[] = [
];



// WEBPACK FOOTER //
// ./src/app/components/common/index.ts